import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { setWindowLocationHref } from 'hs-browser-apis/location';
export function navigateToWorkspace(workspaceId, queryParams) {
  const workspaceUrl = getWorkspaceUrl(workspaceId);
  const params = new URLSearchParams(queryParams);
  const query = params.toString();
  const href = query ? `${workspaceUrl}?${query}` : workspaceUrl;
  setWindowLocationHref(href);
}
export function getWorkspaceUrl(workspaceId) {
  return `${getFullUrl('app')}/breeze-builder/${PortalIdParser.get()}/edit/${workspaceId}`;
}
export function getHomepageUrl() {
  return `${getFullUrl('app')}/breeze-builder/${PortalIdParser.get()}`;
}